import { formatDate } from "devextreme/localization";
import find from "lodash/find";
import isFunction from "lodash/isFunction";
import isNil from "lodash/isNil";
import values from "lodash/values";
import locale from "./format.locale";
export const FORMAT = {
    DATE: "dd.MM.yyyy",
    SHORT_DATE: "dd.MM.yy",
    TIME: "HH:mm:ss",
    SHORT_TIME: "HH:mm",
    DATE_TIME: "dd.MM.yyyy HH:mm:ss",
    DATE_TIME_WITH_IN_TIME_PREPOSITION: `dd.MM.yyyy ${locale.IN_TIME_PREPOSITION} HH:mm:ss`,
    DATE_MONTHS_NAMED: "dd MMMM yyyy",
    DATE_MONTHS_NAMED_SHORT: "dd MMM yyyy"
};
export const formatDateTime = (ms, format = FORMAT.DATE_TIME, isUtc = false, skipZeroValue = true) => {
    if (isNil(ms))
        return "";
    if (skipZeroValue && !ms)
        return "";
    const correctedMs = isUtc ? ms + new Date().getTimezoneOffset() * 60 * 1000 : ms;
    return formatDate(new Date(correctedMs), format);
};
const timeAgoPeriods = {
    HALF_A_YEAR: {
        interval: 6 * 30 * 24 * 60 * 60 * 1000,
        formatter: locale.MORE_THAN_HALF_A_YEAR_AGO
    },
    MONTH: {
        interval: 30 * 24 * 60 * 60 * 1000,
        formatter: locale.buildMonthsAgoText
    },
    WEEK: {
        interval: 7 * 24 * 60 * 60 * 1000,
        formatter: locale.buildWeeksAgoText
    },
    DAY: {
        interval: 24 * 60 * 60 * 1000,
        formatter: locale.buildDaysAgoText
    },
    HOUR: {
        interval: 60 * 60 * 1000,
        formatter: locale.buildHoursAgoText
    },
    MINUTE: {
        interval: 60 * 1000,
        formatter: locale.buildMinutesAgoText
    }
};
export function toTimeAgo(ms) {
    const diff = new Date().getTime() - ms;
    const period = find(values(timeAgoPeriods), e => diff > e.interval);
    if (period)
        return isFunction(period.formatter)
            ? period.formatter(Math.floor(diff / period.interval))
            : period.formatter;
    return locale.JUST_NOW;
}
